const styles = (theme) => ({
  root: {
    width: 320,
  },
  filterField: {
    marginTop: theme.spacing(2),
  },
})

export default styles
